<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <span>{{ $t("inspectionList.backbtn") }}</span>
    </v-tooltip>
    <v-card class="mt-12">
      <v-card-title class="primary white--text font-weight-bold">
        Alerts List
        <v-spacer></v-spacer>
        <v-text-field
          dark
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('repairList.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        sort-by="dateCreated"
        :loading="logsAll.length < 1"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="$store.state.user.company === 'METAX' ? logsAll : logs"
        :search="search"
        :footer-props="{
          itemsPerPageText: $t('repairList.itemsPerPage'),
          itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
        }"
      >
        <template v-slot:item.dateCreated="{ item }">
          {{ item.dateCreated | FixingDate }}
        </template>
        <template v-slot:item.variable="{ item }">
          {{ item.variable }}:
          <span :class="!item.high ? 'green--text ' : '#730D0B--text'">{{
            item.value
          }}</span>
        </template>
        <template v-slot:item.inspection="{ item }">
          <v-btn
            color="primary"
            :to="{
              name: 'InspectionProfile',
              params: { equipTag: item.equipTag, id: item.inspection.id }
            }"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.high="{ item }">
          {{ item.high ? "High Measurement" : "Low Measurement" }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { db } from "@/plugins/db";

import store from "@/store";
export default {
  components: {},
  data() {
    return {
      logsAll: [],
      logs: [],
      search: this.$route.params.equipTag,
      headers: [
        { text: "Equipment Tag", value: "equipTag", align: "center" },
        { text: "Owner", value: "owner", align: "center" },
        { text: "Date", value: "dateCreated", align: "center" },
        { text: "Inspection", value: "inspection", align: "center" },
        { text: "Description", value: "variable", align: "center" },
        { text: "Rango", value: "high", align: "center" }
      ]
    };
  },
  computed: {},
  methods: {
    rowClick: function(item) {
      this.$router.push({
        name: "RepairLogsProfile",
        params: { equipTag: item.equipTag, id: item.id }
      });
      //item  - selected item
    }
  },

  firestore: {
    logs: db
      .collection("logs")
      .where("owner", "==", store.state.user.company)
      .where("disabled", "==", false),
    logsAll: db.collection("logs").where("disabled", "==", false)
  },
  filters: {
    FixingDate: function(value) {
      if (value) {
        return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
      } else {
        return null;
      }
    }
  }
};
</script>
<style>
th {
  vertical-align: middle;
}
</style>
